import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-ink-950 px-4 py-12 sm:py-16" data-id="element-248" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto max-w-2xl lg:max-w-5xl" data-id="element-249" data-mp="3mfhhe7wn41jb">
        <h2 className="text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-250" data-mp="3r7sfr6bqff9r">
          Cosa dicono altri professionisti
        </h2>

        <div className="mt-7 space-y-3 lg:grid lg:grid-cols-2 lg:gap-3 lg:space-y-0" data-id="element-251" data-mp="3k9e7itkvth">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink-900 p-4" data-id="element-252" data-mp="91e3rcx0xfe0">
              <QuoteIcon className="h-5 w-5 text-brand-400/60" aria-hidden="true" data-id="element-253" data-mp="dywe97qow2o4" />
              <blockquote className="mt-2 text-[14.5px] leading-relaxed text-white/80" data-id="element-254" data-mp="2autxwjsblcdq">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-4" data-id="element-255" data-mp="1sk9dcmcuqoe7">
                <img src={item.photo} alt={item.name} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-brand-500/40" loading="lazy" data-id="element-256" data-mp="1smdqluwn4zr5" />
                <div data-id="element-257" data-mp="1etxiwgssodjw">
                  <p className="text-[14px] font-extrabold leading-tight text-white" data-id="element-258" data-mp="1eufpo7d32a62">
                    {item.name}
                  </p>
                  <p className="text-[12.5px] text-white/50" data-id="element-259" data-mp="26kaocumtzc7e">{item.country}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 stelle su 5" data-id="element-260" data-mp="26i7o7hrys2oy">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-brand-400 text-brand-400" aria-hidden="true" data-id="element-261" data-mp="1xk5jar540pwe" data-mpi={i} />)}
                  </div>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-262" data-mp="nmfg6a70e2tr">
          <CTAButton label="Voglio ottenere questi risultati" sublabel="Unisciti ai professionisti che usano il sistema" data-id="element-263" data-mp="sl8wsbhle9y5" />
        </div>
      </div>
    </section>;
}